import { PrevisaoMes } from "../../../../services/home";
import { moeda } from "../formatadores";
import { textoCsv } from "../componentes/csv";

export const CABECALHO_PREVISOES_CSV = ["Mês", "Operadora", "Valor Previsto (R$)"];

const rotuloMes = (mes: PrevisaoMes) => {
  if (!mes.mes) {
    return mes.rotulo;
  }
  const [ano, numero] = mes.mes.split("-");
  return `${numero}/${ano}`;
};

export const linhasPrevisoesCsv = (meses: PrevisaoMes[]): string[][] =>
  meses.reduce(
    (linhas: string[][], mes) =>
      linhas.concat(mes.operadoras.map((operadora) => [rotuloMes(mes), textoCsv(operadora.name), moeda(operadora.y)])),
    []
  );
